import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./caLTable";
import WGRTotals from "./caLTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
  return rows.reduce(
    (sum, row) => {
      const direct = Number(row["DIRECT LABOUR"] || 0);
      const oncost = Number(row["ACTUAL ON COST LABOUR"] || 0);

      return {
        direct: sum.direct + direct,
        oncost: sum.oncost + oncost,
        total: sum.total + direct + oncost,
      };
    },
    {
      direct: 0,
      oncost: 0,
      total: 0,
    }
  );
}, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          
        >
         {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

